export type FaqMockItem = {
  question: string;
  answer: string;
};

export type FaqMockCategory = {
  category: string;
  icon: string;
  items: FaqMockItem[];
};

export const faqCategories: FaqMockCategory[] = [
  {
    category: '聽力損失基礎',
    icon: 'ri-volume-up-line',
    items: [
      {
        question: '什麼是聽力損失？',
        answer: '聽力損失是指聽力下降的程度，無法聽到正常音量範圍內的聲音。聽力損失可分為傳導性、感音神經性及混合性三種。傳導性聽損是外耳或中耳問題，感音神經性聽損是內耳或聽神經受損，混合性則兩者兼有。',
      },
      {
        question: '聽力損失有哪些早期徵兆？',
        answer: '早期徵兆包括：在吵雜環境中難以聽清對話、經常要求對方重複說話、電視音量調得比家人高、聽不到門鈴或電話聲、覺得女性或小孩聲音聽不清楚、耳鳴持續存在。這些症狀容易被忽略，建議定期進行聽力篩檢。',
      },
      {
        question: '聽力損失的程度如何分級？',
        answer: '聽力損失依純音聽力檢查的平均聽力閾值分級：正常（0-25 dB）、輕度（26-40 dB）、中度（41-55 dB）、中重度（56-70 dB）、重度（71-90 dB）及極重度（超過 90 dB）。輕度聽損者通常已經在日常生活中感到溝通困難。',
      },
    ],
  },
  {
    category: '助聽器相關',
    icon: 'ri-headphone-line',
    items: [
      {
        question: '什麼時候需要配戴助聽器？',
        answer: '當聽力損失影響到日常生活溝通時，就建議考慮助聽器。一般來說，輕度聽損（26-40 dB）若已造成溝通困擾，助聽器可以帶來幫助；中度以上聽損則強烈建議使用。助聽器選配需要經由專業聽力師評估後進行。',
      },
      {
        question: '助聽器會不會越戴越聾？',
        answer: '不會。助聽器的主要功能是放大聲音，讓使用者聽得更清楚，並不會進一步損害聽力。相反地，研究顯示長期未使用助聽器的聽損者，因聽覺刺激不足，大腦語言處理能力反而會加速退化。及早配戴助聽器有助於維持聽覺與認知功能。',
      },
      {
        question: '助聽器需要多長時間適應？',
        answer: '適應期因人而異，通常需要 4-12 週。初期可能會覺得聲音太吵或太尖，這是正常的。建議從安靜環境開始，每天配戴 2-4 小時，逐步增加時間。富聆聽的聽力師會在適應期間提供多次調校服務，確保最佳效果。',
      },
      {
        question: '助聽器可以戴著洗澡或游泳嗎？',
        answer: '一般助聽器不防水，不建議戴著洗澡或游泳。市面上有防水等級較高的助聽器型號，但使用前仍需確認規格。日常保養時，應避免讓助聽器接觸水氣、汗水或濕氣過重的環境。建議每天使用除濕盒或電子乾燥器進行保養。',
      },
    ],
  },
  {
    category: '聽力檢測',
    icon: 'ri-stethoscope-line',
    items: [
      {
        question: '聽力檢測需要多長時間？',
        answer: '完整的聽力檢測約需 30-60 分鐘，包括病史詢問、耳鏡檢查、純音聽力檢查、語音辨識測試等。富聆聽提供免費基礎聽力篩檢，約 15-20 分鐘即可完成，適合初步了解自己的聽力狀況。',
      },
      {
        question: '聽力檢測會不會痛？',
        answer: '不會。聽力檢測是無痛的非侵入性檢查。您只需要坐在隔音室內，透過耳機聽到不同頻率與音量的聲音，聽到就按鈕即可。整個過程輕鬆舒適，不會造成任何身體不適。',
      },
      {
        question: '多久應該做一次聽力檢查？',
        answer: '建議 40 歲以上成年人每年檢查一次；65 歲以上長者建議每半年檢查。若有糖尿病、高血壓等慢性病，或長期處於噪音環境，應每半年至一年檢查。兒童建議在出生後、學齡前及入學後定期進行聽力篩檢。',
      },
    ],
  },
  {
    category: '聽力與慢性病',
    icon: 'ri-heart-pulse-line',
    items: [
      {
        question: '糖尿病會影響聽力嗎？',
        answer: '會。糖尿病患者發生聽力損失的風險是正常人的 2.3 倍。長期高血糖會損傷內耳微血管與神經纖維，導致漸進性感音神經性聽損。美國糖尿病學會已將聽力篩檢納入糖友年度檢查建議項目。',
      },
      {
        question: '高血壓與聽力損失有什麼關係？',
        answer: '高血壓會減少內耳血液灌注，加速聽力衰退。研究顯示，收縮壓每升高 10 mmHg，聽損風險增加約 6%。內耳對血流變化極為敏感，因此穩定控制血壓是預防聽力退化的重要措施。',
      },
      {
        question: '聽力損失會增加失智風險嗎？',
        answer: '是的。約翰霍普金斯大學研究發現，重度聽損者認知退化速度比常人快 30-40%，失智風險增加 3.2 倍。這是因為聽覺刺激不足會導致大腦語言處理區域萎縮。早期配戴助聽器可以顯著減緩這一風險。',
      },
    ],
  },
  {
    category: '兒童與銀髮聽力',
    icon: 'ri-parent-line',
    items: [
      {
        question: '如何觀察孩子是否有聽力問題？',
        answer: '嬰幼兒聽力問題的徵兆包括：對聲音沒有反應、不會尋找聲源、語言發展比同齡孩子慢、說話不清楚。學齡兒童可能表現為：上課聽不清楚、成績突然下滑、經常要求重複說話。建議及早帶至耳鼻喉科或聽力中心檢查。',
      },
      {
        question: '長者聽力退化是正常的嗎？',
        answer: '聽力隨年齡增長確實會自然退化，稱為「老年性聽損」。但這不代表無法改善。現代助聽器技術已非常先進，可以有效補償老年性聽損。更重要的是，及早介入可以避免因聽力退化導致的社交孤立、憂鬱及認知退化。',
      },
    ],
  },
  {
    category: '費用與補助',
    icon: 'ri-money-cny-circle-line',
    items: [
      {
        question: '助聽器有政府補助嗎？',
        answer: '有。台灣各縣市政府對聽障者購買助聽器提供補助，一般為每耳 1,000-5,000 元不等，身障程度較重者補助額度較高。申請需經醫院評估並取得身心障礙證明。富聆聽的聽力師可協助您了解申請流程與所需文件。',
      },
      {
        question: '助聽器的價格範圍是多少？',
        answer: '助聽器價格依功能、品牌及技術等級而異，一般單耳價格從 15,000 元到 80,000 元不等。入門級適合輕度聽損，高階款則具備藍牙連線、降噪、AI 自動調節等先進功能。富聆聽提供多種價位選擇，並有分期付款方案。',
      },
    ],
  },
];
